import {ChooseDropdown, DropdownSelectTrigger} from '@priority-software/priority-style-react';
import React from 'react';
import cx from 'classnames';
import {useFontDropdown} from '../../../hooks/useFontDropdown';
import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {LexicalEditor} from 'lexical';
import {createDataTestId} from '../../../../../utils/dataTestId';
import {TMode} from '../../../types';
import {shouldAddDots} from '../../../utils/shouldAddDots';
import styles from './styles.module.scss';

interface IFontDropdownProps {
    options: DropdownItemData[];
    mode: TMode;
    value: DropdownItemData;
    editor: LexicalEditor;
    setIsDropdownOpen?: (isOpen: boolean) => void;
    disabled?: boolean;
    portalSelector?: string;
    componentClasses?: string;
}

export const FontDropdown = ({
    options,
    mode,
    value,
    editor,
    setIsDropdownOpen,
    portalSelector,
    disabled,
    componentClasses
}: IFontDropdownProps) => {
    const {handleChange, isFontSize, selected} = useFontDropdown({mode, value, editor});

    const testID = `toolbar-${isFontSize ? 'font-size' : 'font-family'}`;

    return (
        <div
            {...createDataTestId(`${testID}-container`, false)}
            className={cx(
                componentClasses,
                isFontSize ? styles.fontSizeDropdown : styles.fontFamilyDropdown
            )}
        >
            <ChooseDropdown
                {...createDataTestId(`${testID}-dropdown`, true)}
                data={options}
                hasSearch={false}
                trigger={
                    <DropdownSelectTrigger
                        {...createDataTestId(`${testID}-dropdown-trigger`, true)}
                        size="small"
                        inlinePadding="start"
                        beforeValue={
                            selected ? shouldAddDots(selected.value as string) : value.label
                        }
                    />
                }
                onOpen={() => setIsDropdownOpen?.(true)}
                onChange={handleChange}
                usePortal
                disabled={disabled}
                portalSelector={portalSelector}
                maxScrollHeight={320}
                contentComponentClasses={cx({[styles.dropdownSize]: isFontSize})}
            />
        </div>
    );
};
